import { Box, type SxProps, Typography } from '@mui/material';

export const ComponentTitle = ({ children, sx }: { children: React.ReactNode; sx?: SxProps }) => (
  <Box width='100%'>
    <Typography
      variant='h3'
      align='center'
      fontFamily='Inter'
      fontWeight='500'
      fontSize='1.5rem'
      mb={1}
      borderBottom={3}
      sx={sx || {}}
    >
      {children}
    </Typography>
  </Box>
);
